import usersData from '@/mockData/users.json'
import rolesData from '@/mockData/roles.json'
import userRolesData from '@/mockData/user_roles.json'
import UsersService from '@/services/api/users.services'
import store from '@/store'
import ApiClient from '@/libs/http-client'

function checkLength(val) {
    return String(val).length === 1 ? '0' + val : val
}

const state = {
    users: usersData,
    roles: rolesData,
    birthdays: [],
    closeBirthdays: [],
    usersForBirthdays: [],
    usersList: [],
    usersListAll: [],
    getUserClients: [],
    userPositions: [],
    userRoles: userRolesData,
    employeesList: [],
    clientsList: [],
    currentClient: null,
}

const mutations = {
    SET_USERS(state, payload) {
        state.usersList = payload
    },
    SET_ALL_USERS(state, payload) {
        state.usersListAll = payload
    },
    SET_EMPLOYEES(state, payload) {
        state.employeesList = payload
    },
    SET_CURRENT_CLIENT(state, payload) {
        state.currentClient = payload
    },
    SET_CLIENTS(state, payload) {
        state.clientsList = payload
    },
    SET_BIRTHDAYS(state, payload) {
        state.usersForBirthdays = payload.map((item) => {
            return {
                user_id: item.id,
                user_name: item.user_name,
                firstname: item.first_name,
                lastname: item.last_name,
                birthday: item.birthday,
                role: item.role,
            }
        })

        const birthdays = payload.map((item) => {
            return {
                id: item.id,
                title: item.user_name,
                birthday: item.birthday,
                age:
                    new Date().getFullYear() -
                    new Date(item.birthday).getFullYear(),
                start: `${new Date().getFullYear()}-${checkLength(
                    new Date(item.birthday).getMonth() + 1,
                )}-${checkLength(new Date(item.birthday).getDate())}`,
                end: `${new Date().getFullYear()}-${checkLength(
                    new Date(item.birthday).getMonth() + 1,
                )}-${checkLength(new Date(item.birthday).getDate())}`,
            }
        })

        let res = []

        birthdays.forEach((item) => {
            for (let i = -10; i < 10; i++) {
                res.push({
                    title: item.title,
                    birthday: item.birthday,
                    age:
                        new Date().getFullYear() -
                        i -
                        new Date(item.birthday).getFullYear(),
                    start: `${new Date().getFullYear() - i}-${checkLength(
                        new Date(item.birthday).getMonth() + 1,
                    )}-${checkLength(new Date(item.birthday).getDate())}`,
                    end: `${new Date().getFullYear() - i}-${checkLength(
                        new Date(item.birthday).getMonth() + 1,
                    )}-${checkLength(new Date(item.birthday).getDate())}`,
                })
            }
        })

        state.birthdays = res
    },
    SET_CLOSE_BIRTHDAYS(state, payload) {
        state.closeBirthdays = payload
            .map((item) => {
                return {
                    user: item.user_name,
                    birthday: `${new Date().getFullYear()}-${checkLength(
                        new Date(item.birthday).getMonth() + 1,
                    )}-${checkLength(new Date(item.birthday).getDate())}`,
                    age:
                        new Date().getFullYear() -
                        new Date(item.birthday).getFullYear(),
                    shortDate: `${new Date(
                        item.birthday,
                    ).getDate()}.${checkLength(
                        Number(new Date(item.birthday).getMonth()) + 1,
                    )}`,
                }
            })
            .filter(
                (item) =>
                    Math.abs(
                        new Date().getTime() -
                            new Date(item.birthday).getTime(),
                    ) /
                        (1000 * 3600 * 24) <
                        7 &&
                    (new Date().getTime() - new Date(item.birthday)) /
                        (1000 * 3600 * 24),
            )
    },
    SET_USER_CLIENTS(state, payload) {
        state.userClients = payload
    },
    SET_USER_POSITIONS(state, payload) {
        state.userPositions = payload
    },
    SET_USER_ROLES(state, payload) {
        state.userRoles = payload
    },
}

const actions = {
  getActiveUsers({ commit }) {
        return new Promise((resolve, reject) => {
            UsersService.get('getActiveUsers')
                .then((response) => {
                    commit('SET_USERS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getUsersList({ commit }) {
        return new Promise((resolve, reject) => {
            UsersService.get('getActiveUsers')
                .then((response) => {
                    commit('SET_USERS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getAllUsersList({ commit, state }, forceRefresh = false) {
        if (!forceRefresh && state.usersListAll && state.usersListAll.length > 0) {
            return Promise.resolve({ data: { data: state.usersListAll } })
        }
        return new Promise((resolve, reject) => {
            UsersService.get('getAllUsers')
                .then((response) => {
                    commit('SET_ALL_USERS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getEmployees({ commit, state }, forceRefresh = false) {
        if (!forceRefresh && state.employeesList && state.employeesList.length > 0) {
            return Promise.resolve({ data: { data: state.employeesList } })
        }
        return new Promise((resolve, reject) => {
            UsersService.getCurrentEmployees()
                .then((response) => {
                    commit('SET_EMPLOYEES', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getClients({ commit }) {
        return new Promise((resolve, reject) => {
            UsersService.getCurrentClients()
                .then((response) => {
                    commit('SET_CLIENTS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getActiveClients({ commit }) {
        return new Promise((resolve, reject) => {
            ApiClient.get('/api/clients?acive=1')
                .then((response) => {
                    commit('SET_CLIENTS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getActiveProjects({ commit }) {
        return new Promise((resolve, reject) => {
            ApiClient.get('/api/projects?active=1')
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getAccounts({ commit }) {
        return new Promise((resolve, reject) => {
            ApiClient.get('/api/accounts', {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    },

    getEntities({ commit }) {
        return new Promise((resolve, reject) => {
            ApiClient.get('/api/legal-entities', {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    },

    getCountries({ commit }) {
        return new Promise((resolve, reject) => {
            ApiClient.get('/api/countries', {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    },
    getCurrentClient({ commit }, id) {
        return new Promise((resolve, reject) => {
            UsersService.get('getCurrentClient', id)
                .then((response) => {
                    commit('SET_CURRENT_CLIENT', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getEntity(_, id) {
        return new Promise((resolve, reject) => {
            ApiClient.get(`/api/legal-entities/${id}`)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getAccount(_, id) {
        return new Promise((resolve, reject) => {
            ApiClient.get(`/api/accounts/${id}`)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getСurrencies(_) {
        return new Promise((resolve, reject) => {
            ApiClient.get(`api/currencies`)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getСountries(_) {
        return new Promise((resolve, reject) => {
            ApiClient.get(`api/countries`)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    createEntity({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ApiClient.post('api/legal-entities', payload, {
                headers: {
                    Accept: 'application/json',
                },
            })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    createAccount({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ApiClient.post('api/accounts', payload, {
                headers: {
                    Accept: 'application/json',
                },
            })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    editAccount({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ApiClient.put(`api/accounts/${payload.id}`, payload, {
                headers: {
                    Accept: 'application/json',
                },
            })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    editEntity({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ApiClient.put(`api/legal-entities/${payload.id}`, payload, {
                headers: {
                    Accept: 'application/json',
                },
            })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    changePassword(context, payload) {
        return new Promise((resolve, reject) => {
            UsersService.put('changePassword', {}, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    changeAvatar(context, data) {
        return new Promise((resolve, reject) => {
            UsersService.post('updateProfileData', {}, data, {
                headers: {
                    Accept: '*/*',
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((response) => {
                    store.dispatch(
                        'authorization/getPersonalData',
                        response.data.data,
                    ) // changing users photo
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    changeGeneralData(context, data) {
        return new Promise((resolve, reject) => {
            UsersService.post('updateProfileData', {}, data, {
                headers: {
                    Accept: '*/*',
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((response) => {
                    store.dispatch(
                        'authorization/getPersonalData',
                        response.data.data,
                    ) // changing users data
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    addNewUser({ commit }, payload) {
        return new Promise((resolve, reject) => {
            UsersService.post('updateProfileData', {}, payload, {
                headers: {
                    Accept: 'application/json',
                },
            })
                .then(() => {
                    UsersService.get('getUsers')
                        .then((response) => {
                            commit('SET_BIRTHDAYS', response.data.data)
                            resolve(response)
                        })
                        .catch((error) => reject(error))
                })
                .catch((error) => reject(error))
        })
    },

    addNewClient(_, payload) {
        return new Promise((resolve, reject) => {
            UsersService.post('addClient', {}, payload, {
                headers: {
                    Accept: 'application/json',
                    // "Content-Type": "multipart/form-data",
                },
            })
                .then((response) => {
                    resolve(response.data.data)
                })
                .catch((error) => reject(error))
        })
    },

    changeNotOwnUserData({ commit }, payload) {
        return new Promise((resolve, reject) => {
            UsersService.changeNotOwnUserData(payload.userId, payload.form)
                .then(() => {
                    UsersService.get('getUsers')
                        .then((response) => {
                            commit('SET_BIRTHDAYS', response.data.data)
                            resolve(response)
                        })
                        .catch((error) => reject(error))
                })
                .catch((error) => reject(error))
        })
    },

    updateUserNotifications({ dispatch }, payload) {
        return new Promise((resolve, reject) => {
            UsersService.changeNotOwnUserData(payload.userId, {
                notifications: payload.notifications,
            })
                .then((response) => {
                    const promises = [dispatch('getAllUsersList', true)]
                    const currentUser = store.getters['authorization/getCurrentUser']
                    if (currentUser?.id === payload.userId) {
                        promises.push(store.dispatch('authorization/getPersonalData'))
                    }
                    Promise.all(promises)
                        .then(() => resolve(response))
                        .catch((error) => reject(error))
                })
                .catch((error) => reject(error))
        })
    },

    changeClientData(_, payload) {
        return new Promise((resolve, reject) => {
            ApiClient.patch(`/api/clients/${payload.userId}`, payload.form)
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    },

    changeEntityData(_, payload) {
        return new Promise((resolve, reject) => {
            ApiClient.patch(`/api/accounts/${payload.userId}`, payload.form)
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    },

    changeDateOfBirth({ commit }, form) {
        return new Promise((resolve, reject) => {
            UsersService.changeDateOfBirth(form.userId, {
                birthday: form.birthday,
            })
                .then(() => {
                    UsersService.get('getUsers')
                        .then((response) => {
                            commit('SET_BIRTHDAYS', response.data.data)
                            resolve(response)
                        })
                        .catch((error) => reject(error))
                })
                .catch((error) => reject(error))
        })
    },
    getCalendarBirthdays({ commit }) {
        return new Promise((resolve, reject) => {
            UsersService.get('getUsers')
                .then((response) => {
                    commit('SET_BIRTHDAYS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getCloseBirthdays({ commit }) {
        return new Promise((resolve, reject) => {
            UsersService.get('getUsers')
                .then((response) => {
                    commit('SET_CLOSE_BIRTHDAYS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getUserClients({ commit }, payload) {
        return new Promise((resolve, reject) => {
            UsersService.getUserClients(payload)
                .then((response) => {
                    commit('SET_USER_CLIENTS', response.data.data)

                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    updateUserRoles({ commit }, payload) {
        return new Promise((resolve, reject) => {
            UsersService.put('editProfileData', payload.userId, {
                role_ids: [...payload.roleIds],
            })
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    onboardUser({ commit }, payload) {
        return new Promise((resolve, reject) => {
            UsersService.post('onboardUser', {}, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    offboardUser({ commit }, payload) {
        return new Promise((resolve, reject) => {
            UsersService.post('offboardUser', {}, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    getEmployeesList: (state) => state.employeesList,
    getClientsList: (state) => state.clientsList,
    getUsersList: (state) => state.usersList,
    getAllUsersList: (state) => state.usersListAll,
    getData: (state) => state.users,
    getWorkers: (state) =>
        state.users.filter((item) =>
            item.roles.find((item) => item !== 'chief'),
        ),
    getChiefs: (state) =>
        state.users.filter((item) =>
            item.roles.find((item) => item === 'chief'),
        ),
    getUserInfo: (state) => (nickname) =>
        state.usersList.find((item) => item.user_name === nickname),
    getRolesInfo: (state) => (nickname, route) => {
        const userRoles = Object.keys(state.roles)
            .filter(
                (item) =>
                    state.users
                        .find((item) => item.nickname === nickname)
                        .roles.indexOf(item) !== -1,
            )
            .map((item) => (item = state.roles[item][route]))

        return {
            add: userRoles.some((item) => item['add'] === true),
            'show own': userRoles.some((item) => item['show own'] === true),
            'show all': userRoles.some((item) => item['show all'] === true),
            'edit own': userRoles.some((item) => item['edit own'] === true),
            'edit all': userRoles.some((item) => item['edit all'] === true),
            'delete own': userRoles.some((item) => item['delete own'] === true),
            'delete all': userRoles.some((item) => item['delete all'] === true),
        }
    },
    getBirthdays: (state) => state.birthdays,
    getCloseBirthdays: (state) => state.closeBirthdays,
    getUsersForBirthdays: (state) => state.usersForBirthdays,
    getUserClients: (state) => state.userClients,
    getUserPositions: (state) => state.userPositions,
    getUserRoles: (state) => state.userRoles,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
